import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ChatbotFlowComponent } from './pages/dashboard/chatbot-flow/chatbot-flow.component';
import { MicroLearningContentComponent } from './pages/dashboard/micro-learning-content/micro-learning-content.component';
import { ChatbotResponse } from './pages/dashboard/chatbot-flow/chatbot-flow.component';
import { MicroLearningResponse } from './pages/dashboard/micro-learning-content/micro-learning-content.component';
import { ActivityLogComponent } from './pages/dashboard/activity-log/activity-log.component';
import { Constants } from './config/constant';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { UserActivityComponent } from './pages/dashboard/user-activity/user-activity.component';
import { ShipActivityComponent } from './pages/dashboard/ship-activity/ship-activity.component';
import { MixpanelService } from './services/mixpanel.service';
import { GamesComponent } from './pages/dashboard/games/games.component';
import { GameMenuComponent } from './pages/dashboard/games/game-menu/game-menu.component';
import { PlayComponent } from './pages/dashboard/games/play/play.component';
import { ExitGameService } from './guard/exit-game.service';
import { ExitGameDialog } from './pages/dashboard/games/exit-game-dialog.component';
import { LogoutDialog } from './pages/logout/logout-dialog.component';
import { UploadDialog } from './pages/dashboard/upload-dailog.component';
import { ReportsComponent } from './pages/dashboard/reports/reports.component';
import { AnalyticsComponent } from './pages/dashboard/analytics/analytics.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { FaqComponent } from './pages/dashboard/faq/faq.component';
import { ClientOnboardingComponent } from './pages/dashboard/client-onboarding/client-onboarding.component';
import { ChartsComponent } from './pages/dashboard/charts/charts.component';
import { ZohoLinksComponent } from './pages/dashboard/zoho-links/zoho-links.component';
import { SynopsisComponent } from './pages/dashboard/synopsis/synopsis.component';
import { OshComponent } from './pages/dashboard/osh/osh.component';
import { GamesExcelComponent } from './pages/dashboard/games-excel/games-excel.component';
import { DocumentarchivesComponent } from './pages/dashboard/documentarchives/documentarchives.component';
import { UploaddocumentComponent } from './pages/dashboard/documentarchives/uploaddocument/uploaddocument.component';
import { DocumentpageComponent } from './pages/dashboard/documentarchives/documentpage/documentpage.component';
import { SynopsisPopupComponent } from './pages/dashboard/synopsis/synopsis-popup/synopsis-popup.component';
import { FeedbackComponent } from './pages/dashboard/synopsis/feedback/feedback.component';
import { VideoLibraryUploadComponent } from './pages/dashboard/video-library-upload/video-library-upload.component';
import { PemeContentComponent } from './pages/dashboard/peme-content/peme-content.component';
import { PemeCheckinsComponent } from './pages/dashboard/peme-checkins/peme-checkins.component';
import { PemeDailyTaskComponent } from './pages/dashboard/peme-daily-task/peme-daily-task.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ChatbotFlowComponent,
    MicroLearningContentComponent,
    ActivityLogComponent,
    ChatbotResponse,
    MicroLearningResponse,
    UserActivityComponent,
    ShipActivityComponent,
    GamesComponent,
    GameMenuComponent,
    ExitGameDialog,
    LogoutDialog,
    UploadDialog,
    PlayComponent,
    ReportsComponent,
    AnalyticsComponent,
    FaqComponent,
    ClientOnboardingComponent,
    ChartsComponent,
    ZohoLinksComponent,
    SynopsisComponent,
    OshComponent,
    GamesExcelComponent,
    DocumentarchivesComponent,
    UploaddocumentComponent,
    DocumentpageComponent,
    SynopsisPopupComponent,
    FeedbackComponent,
    VideoLibraryUploadComponent,
    PemeContentComponent,
    PemeCheckinsComponent,
    PemeDailyTaskComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    MatTooltipModule,
    MatDialogModule,
    MatCardModule,
    MatProgressBarModule,
    MatTabsModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HighchartsChartModule,
  ],
  providers: [Constants, MixpanelService, ExitGameService],
  bootstrap: [AppComponent],
})
export class AppModule { }
